module.exports = __webpack_public_path__ + "media/images/fav/optiv_favicon-f59b07a7fe6b3237d0ad50d460a097ba.ico";